import type { AuthTokenProvider } from '../type';

/**
 * The auth provider the request interceptor reads from.
 *
 * Starts unset so this library has no dependency on `@realtyfeed/auth` (see the
 * note on `AuthTokenProvider`). Each app registers the real one in `main.tsx`
 * before rendering; anything that fires before then goes out unauthenticated,
 * which is correct for the handful of public endpoints and correctly rejected for
 * the rest.
 */
let provider: AuthTokenProvider | null = null;

export const registerAuthTokenProvider = (next: AuthTokenProvider): void => {
  provider = next;
};

export const getAuthTokenProvider = (): AuthTokenProvider | null => provider;

/** Test seam - drops the registration so suites don't leak one into the next. */
export const clearAuthTokenProvider = (): void => {
  provider = null;
};
